import apiSlice from "./apiSlice";

const constructionDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getConstructionProgressKpi: builder.query({
            query: ({ projectId }) => ({
                url: `construction/progress-kpi`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ConstructionProgressKpi"],
        }),

        getConstructionPlanVsActual: builder.query({
            query: ({ projectId }) => ({
                url: `construction/plan-vs-actual`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ConstructionPlanVsActual"],
        }),

        getConstructionProgressCurve: builder.query({
            query: ({ projectId }) => ({
                url: `construction/progress-curve`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ConstructionProgressCurve"],
        }),

        getConstructionVarianceDrivers: builder.query({
            query: ({ projectId, month }) => ({
                url: `construction/variance-drivers`,
                params: {
                    projectId,
                    ...(month ? { month } : {}),
                },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ConstructionVarianceDrivers"],
        }),
    }),
});

export const {
    useGetConstructionProgressKpiQuery,
    useGetConstructionPlanVsActualQuery,
    useGetConstructionProgressCurveQuery,
    useGetConstructionVarianceDriversQuery,
} = constructionDashboardApiSlice;
